var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6745 18.2778V1.98193C7.51004 2.33662 1 9.07573 1 17.3386C1 25.8285 7.87265 32.7123 16.3487 32.7123C24.5104 32.7123 31.1819 26.3307 31.6663 18.2778H15.6745Z",
    stroke: "#231F20",
    strokeWidth: 1.538,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4478 0V14.4146H34.4084C33.9239 6.48657 27.4422 0.184439 19.4478 0Z",
    fill: "#106B46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.84a012976f2cefb36414ffb084d9c703.svg";
export { ForwardRef as ReactComponent };